<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.timeDimension" @change="changeTimeType">
                    <el-option
                      v-for="(item, index) in timeTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </template>
              <el-date-picker
                v-model="queryDateTime"
                :end-placeholder="$t('operationCenter.endDate')"
                :picker-options="pickerOptions"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <!-- 大区 -->
          <el-col :span="5">
            <el-form-item :label="$t('tablePrice.region')">
              <el-select
                v-model="queryForm.params.stateOrSite"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--州 -->
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.state')">
              <el-select
                v-model="queryForm.params.regionOrState"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--  投诉来源  -->
            <el-form-item :label="$t('tablePrice.complaintType')">
              <el-select
                v-model="queryForm.params.complaintSource"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in complaintSourceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--  处理结果  -->
            <el-form-item :label="$t('collectionCenter.processingResult')">
              <el-select
                v-model="queryForm.params.processingResult"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in complaintTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--  4179 客户名称  -->
            <el-form-item :label="$t('tablePrice.customerName')">
              <el-select
                v-model="selectedCustomerIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="searchCustomers"
                clearable
                collapse-tags
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @change="handleCustomerChange"
              >
                <el-option
                  v-for="item in visibleCustomers"
                  :key="item.customerId"
                  :label="item.customerName"
                  :value="item.customerId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--  4179 商户名称（跟客户联动：先选客户）  -->
            <el-form-item :label="$t('tablePrice.merchantName')">
              <el-select
                v-model="selectedMerchantKeys"
                :disabled="!selectedCustomerIds || !selectedCustomerIds.length"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="searchMerchants"
                clearable
                collapse-tags
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
              >
                <el-option
                  v-for="item in visibleMerchants"
                  :key="item.customerId + ':' + item.merchantCode"
                  :label="item.merchantName ? item.merchantName + '(' + item.merchantCode + ')' : item.merchantCode"
                  :value="item.customerId + ':' + item.merchantCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="btnSearch(1)"
              >{{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="btnSearch(2)">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                size="small" @click="allExportOrder"
              >{{ $t('newOrder.export') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ color: 'black' }"
      :span-method="objectSpanMethod"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('tablePrice.region')"
        align="center"
        min-width="120"
        prop="regionOrStateName"
      />
      <el-table-column :label="$t('collectionCenter.state')" min-width="120" prop="stateOrSite" />
      <el-table-column
        :label="$t('tablePrice.monthToDate')"
        min-width="120"
        prop="currentMonthFalseSignCount"
        :formatter="thousandFormat"
      />
      <el-table-column
        :label="$t('tablePrice.dailyAverage')"
        min-width="120"
        prop="avgOfSearchDay"
        :formatter="thousandFormat"
      />
      <el-table-column :label="$t('tablePrice.totalText')" align="center">
        <el-table-column
          :label="$t('tablePrice.falseDeliveryCount')"
          min-width="150"
          prop="falseSignCount"
          :formatter="thousandFormat"
        />
        <el-table-column
          :label="$t('tablePrice.deliveryCount')"
          min-width="150"
          prop="signedCount"
          :formatter="thousandFormat"
        />
        <el-table-column
          :label="$t('tablePrice.falseDeliveryRate')"
          min-width="150"
          prop="signRate"
        />
      </el-table-column>
      <el-table-column
        v-for="item in columnList" :key="item.id" :label="item.label"
        align="center"
      >
        <el-table-column
          :label="$t('tablePrice.falseDeliveryCount')"
          :prop="item.falseSignCount"
          :formatter="thousandFormat"
          min-width="150"
        />
        <el-table-column
          :label="$t('tablePrice.deliveryCount')"
          :prop="item.signedCount"
          :formatter="thousandFormat"
          min-width="150"
        />
        <el-table-column
          :label="$t('tablePrice.falseDeliveryRate')"
          :prop="item.signRate"
          min-width="150"
        />
      </el-table-column>
      <el-table-column
        :label="$t('tablePrice.dayOverDay')"
        align="center"
        min-width="120"
        prop="dailyComparison"
      >
        <template slot-scope="scope">
          <div :style="{ color: scope.row.dailyComparisonStyle ? '#009c37' : 'red' }">
            {{ scope.row.dailyComparison || '--' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('tablePrice.weekOverWeek')"
        align="center"
        min-width="120"
        prop="weeklyComparison"
      >
        <template slot-scope="scope">
          <div :style="{ color: scope.row.weeklyComparisonStyle ? '#009c37' : 'red' }">
            {{ scope.row.weeklyComparison || '--' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('tablePrice.monthOverMonth')"
        align="center"
        min-width="120"
        prop="monthlyComparison"
      >
        <template slot-scope="scope">
          <div :style="{ color: scope.row.monthlyComparisonStyle ? '#009c37' : 'red' }">
            {{ scope.row.monthlyComparison || '--' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="getCurrentTableData"
        @size-change="getSizeTableData"
      />
    </div>
  </div>
</template>

<script>
import { getLgAreaListData, regionQueryList } from '@/api/orderApi';
import dayjs from 'dayjs';
import {
  failSignReportExport,
  falseSignDailyReportSitePage,
  falseSignDailyReportSiteSummary,
  getCustomerFilterOptions
} from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';
import { complaintSource, complaintType3 } from '@/utils/enumData';
import { formatNumber } from '@/utils/tools';

export default {
  name: 'ReturnDataMonitoring',
  data() {
    return {
      timeTypeList: [
        { label: this.$t('collectionCenter.closeTime'), value: 0 },
        { label: this.$t('GlobalSetObj.Deadline'), value: 1 },
        { label: this.$t('collectionCenter.signT'), value: 2 }
      ],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          type: 1,
          stateOrSite: '',
          regionOrState: '',
          complaintSource: '',
          processingResult: '',
          timeDimension: 0
        }
      },
      total: 0,
      stateList: [], // 州
      tableData: [],
      columnList: [],
      queryDateTime: [this.getAWeek().startDate, this.getAWeek().endDate],
      // 4179 客户/商户筛选（网点/大区维度）
      selectedCustomerIds: [],
      selectedMerchantKeys: [],
      // 分页远程搜索（肖强要求）：输入关键字调接口取前10条，不全量下发
      visibleCustomers: [],
      visibleMerchants: [],
      flattenedObject: {},
      resultObj: {},
      regionList: [],
      complaintSourceList: complaintSource,
      complaintTypeList: complaintType3,
      choiceDate0: '',
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() - 30);
          const maxTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() + 30);
          const min = minTime;
          // const newDate = new Date(new Date().toLocaleDateString()).getTime();
          const d = new Date();
          d.setHours(0, 0, 0, 0);
          d.setDate(d.getDate() + 1);
          const newDate = d.getTime();
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      spanArr: [] // 用于存储每一行的合并信息
    };
  },
  watch: {
    'queryForm.params.stateOrSite'(newVal) {
      if (newVal && this.regionList.length > 0) {
        this.queryForm.params.regionOrState = '';
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateList = selectedRegion.states.map((label) => ({ label }));
        }
      } else {
        this.stateList = [];
        this.getAddress();
      }
    }
  },
  created() {
    // 获取加盟商选项
    this.getAddress();
    this.getSearch(1);
    this.searchCustomers('');
    this.getRegion();
  },
  methods: {
    // 4179 客户下拉：分页远程搜索（接口按 keyword 各取前10，标杆 logisticsOrders search.vue）
    searchCustomers(name) {
      getCustomerFilterOptions(name || '').then((res) => {
        if (res.code === 200) {
          this.visibleCustomers = (res.data && res.data.customers) || [];
        }
      });
    },
    // 4179 商户下拉：分页远程搜索（带已选客户联动过滤）
    searchMerchants(name) {
      getCustomerFilterOptions(name || '', this.selectedCustomerIds || []).then((res) => {
        if (res.code === 200) {
          this.visibleMerchants = (res.data && res.data.merchants) || [];
        }
      });
    },
    // 4179 客户变化联动：清掉不属于已选客户的商户
    handleCustomerChange(vals) {
      if (vals && vals.length) {
        this.selectedMerchantKeys = this.selectedMerchantKeys.filter((k) => vals.includes(Number(k.split(':')[0])));
      } else {
        this.selectedMerchantKeys = [];
      }
    },
    // 4179 拼 customerKeys：客户未选商户→纯客户ID(该客户全部)；选了商户→客户ID:商户码
    buildCustomerKeys() {
      const cids = this.selectedCustomerIds || [];
      if (!cids.length) return [];
      const keys = [];
      cids.forEach((cid) => {
        const mks = (this.selectedMerchantKeys || []).filter((k) => k.startsWith(cid + ':'));
        if (mks.length) {
          keys.push(...mks);
        } else {
          keys.push(String(cid));
        }
      });
      return keys;
    },
    // 时间维度提示：0=闭环时间 1=截止时间 2=签收时间，与 timeTypeList 和后端 timeDimension 一致
    changeTimeType(val) {
      if (val === 0) {
        this.$message.info(this.$t('collectionCenter.switchedToClosedLoopView'));
      } else if (val === 1) {
        this.$message.info(this.$t('collectionCenter.switchedToDeadlineView'));
      } else if (val === 2) {
        this.$message.info(this.$t('collectionCenter.switchedToSignTimeView'));
      }
    },
    // 导出
    allExportOrder() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          type: 1,
          regionOrState: [],
          stateOrSite: [],
          startTime: '',
          endTime: '',
          complaintSource: this.queryForm.params.complaintSource,
          processingResult: this.queryForm.params.processingResult,
          timeDimension: this.queryForm.params.timeDimension,
          customerKeys: this.buildCustomerKeys()
        }
      };
      if (this.queryForm.params.stateOrSite) {
        const stateOrSite = this.queryForm.params.stateOrSite.toString();
        data.params.regionOrState = [stateOrSite];
      }
      if (this.queryForm.params.regionOrState) {
        data.params.stateOrSite = [this.queryForm.params.regionOrState];
      }
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startTime = this.queryDateTime[0];
        data.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      failSignReportExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    handleRegionList(val) {
      this.queryForm.params.regionOrState = '';
      console.log(val, 'handleRegionList');
      const obj = this.regionList.find((item) => item.code === val);
      console.log(obj, 'handleRegionList');
      if (obj) {
        this.stateList = [];
        obj.codes.forEach((item, index) => {
          const object1 = {
            id: index,
            label: item
          };
          this.stateList.push(object1);
        });
      } else {
        this.getAddress();
      }
    },
    // 搜索、重置
    btnSearch(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getSearch();
      } else {
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            stateOrSite: '',
            regionOrState: '',
            complaintSource: '',
            processingResult: '',
            timeDimension: 0
          }
        };
        this.queryDateTime = [this.getAWeek().startDate, this.getAWeek().endDate];
        // 4179 重置客户/商户筛选
        this.selectedCustomerIds = [];
        this.selectedMerchantKeys = [];
        this.searchCustomers('');
        this.visibleMerchants = [];
        this.getSearch();
        this.getAddress();
      }
    },
    // 获取最近30天时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD')
      };
    },
    // 获取加盟商时效统计列表
    getSearch(val) {
      this.columnList = [];
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          type: 1,
          regionOrState: [],
          stateOrSite: [],
          startTime: '',
          endTime: '',
          complaintSource: this.queryForm.params.complaintSource,
          processingResult: this.queryForm.params.processingResult,
          timeDimension: this.queryForm.params.timeDimension,
          customerKeys: this.buildCustomerKeys()
        }
      };
      if (this.queryForm.params.stateOrSite) {
        const stateOrSite = this.queryForm.params.stateOrSite.toString();
        data.params.regionOrState = [stateOrSite];
      }
      if (this.queryForm.params.regionOrState) {
        data.params.stateOrSite = [this.queryForm.params.regionOrState];
      }
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startTime = this.queryDateTime[0];
        data.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      falseSignDailyReportSitePage(data)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records;
            this.tableData[0].detailList.forEach((item, index) => {
              const data = {
                id: index,
                label: item.statTime,
                falseSignCount: 'falseSignCount' + index,
                signedCount: 'signedCount' + index,
                signRate: 'signRate' + index
              };
              this.columnList.push(data);
            });
            const arr = this.tableData.map((item, index) => {
              item.stateOrSite = item.stateOrSite || item.stateOrSiteName; // 州合计行
              const newItem = { ...item };
              delete newItem.detailList;
              item.detailList.forEach((detail, detailIndex) => {
                ['signedCount', 'signRate', 'falseSignCount'].forEach((key) => {
                  newItem[`${key}${String(detailIndex).padStart(1, '0')}`] = detail[key];
                });
              });
              return newItem;
            });
            this.tableData = arr;
            falseSignDailyReportSiteSummary(data.params).then((res) => {
              res.data.stateOrSite = this.$t('GlobalSetObj.Total');
              res.data.regionOrStateName = this.$t('GlobalSetObj.Total');
              const arr1 = [res.data];
              const arr2 = arr1.map((item, index) => {
                const newItem = { ...item };
                delete newItem.detailList;
                item.detailList.forEach((detail, detailIndex) => {
                  ['signedCount', 'signRate', 'falseSignCount'].forEach((key) => {
                    newItem[`${key}${String(detailIndex).padStart(1, '0')}`] = detail[key];
                  });
                });
                return newItem;
              });
              this.tableData.unshift(arr2[0]);
              this.tableData.forEach((item) => {
                item.dailyComparisonStyle = this.isPercentageGreaterThanZero(item.dailyComparison);
                item.weeklyComparisonStyle = this.isPercentageGreaterThanZero(item.weeklyComparison);
                item.monthlyComparisonStyle = this.isPercentageGreaterThanZero(
                  item.monthlyComparison
                );
              });
              this.getSpanArr(this.tableData);
            });
            if (val === 1) {
              loading.close();
            }
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 获取大区列表
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    // 合并表格
    getSpanArr(data) {
      this.spanArr = [];
      this.pos = 0;
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前行的 type 是否和上一行相同
          if (data[i].regionOrState === data[i - 1].regionOrState) {
            this.spanArr[this.pos]++;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    // 判断百分比是否大于零
    isPercentageGreaterThanZero(percentageStr) {
      const numberStr = percentageStr.replace('%', '');
      const number = parseFloat(numberStr) / 100;
      return number > 0;
    },
    // 千分位格式化（整数；中文 1,000 / 葡语 1.000）
    thousandFormat(_row, _column, cellValue) {
      return formatNumber(cellValue, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
table {
  border: 1px solid black;
  border-collapse: collapse;
  width: 100%;
  text-align: center;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}
.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

</style>
